import moment from "moment";

export const BASE_URL = process.env.REACT_APP_API_LINK;

export const CONFIG = {
    "api-key": process.env.REACT_APP_API_KEY,
    "Content-Type": "application/json",
    "latitude": "1",
    "longitude": "1",
};

export const FORM_DATA_CONFIG = {
    "api-key": process.env.REACT_APP_API_KEY,
    "Content-Type": "multipart/form-data",
    "latitude": "1",
    "longitude": "1",
};

export const formatDate = (date) => {
    return moment(date).format("M/DD/YY, h:mm a");   
}

export const titleCase = (str) => {
    return str.toLowerCase().split(' ').map(function (word) {
        return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');  
}